'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _pack = require('./pack');

var _pack2 = _interopRequireDefault(_pack);

var _unpack = require('./unpack');

var _unpack2 = _interopRequireDefault(_unpack);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function wrap() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      idField = _ref.idField,
      operations = _ref.operations;

  if (!operations) {
    throw new Error('tree.wrap - Missing operations!');
  }

  return _redux.compose.apply(undefined, [(0, _unpack2.default)({ idField: idField })].concat(_toConsumableArray(operations), [(0, _pack2.default)({ idField: idField })]));
}

exports.default = wrap;